/**
 * Fixed, with no per-user selector, and matching the backoffice's own `FULL_PAGE_SIZE` - see that
 * file for why it is not tied to the detail pane's height.
 */
export const FULL_PAGE_SIZE = 15;

/**
 * The backend's own ceiling (`PagingDefaults.MaxPageSize`), which covers every whole-set caller
 * in one request.
 */
export const UNPAGINATED_FETCH_SIZE = 200;

/**
 * `format: int32` reaches the client as `string | number`, though never a string on the wire.
 * One cast here rather than at every read site.
 */
export function toNumber(value: number | string): number {
  return typeof value === "number" ? value : Number(value);
}
